var map = {
	"./default.png": "./admin-thumbs/default.png",
	"./s-block-links.png": "./admin-thumbs/s-block-links.png",
	"./s-blocks-carousel.png": "./admin-thumbs/s-blocks-carousel.png",
	"./s-blocks.png": "./admin-thumbs/s-blocks.png",
	"./s-columns.png": "./admin-thumbs/s-columns.png",
	"./s-contact.png": "./admin-thumbs/s-contact.png",
	"./s-cta.png": "./admin-thumbs/s-cta.png",
	"./s-editor.png": "./admin-thumbs/s-editor.png",
	"./s-facts.png": "./admin-thumbs/s-facts.png",
	"./s-faq.png": "./admin-thumbs/s-faq.png",
	"./s-header.png": "./admin-thumbs/s-header.png",
	"./s-hero.png": "./admin-thumbs/s-hero.png",
	"./s-highlight.png": "./admin-thumbs/s-highlight.png",
	"./s-list.png": "./admin-thumbs/s-list.png",
	"./s-logos.png": "./admin-thumbs/s-logos.png",
	"./s-media.png": "./admin-thumbs/s-media.png",
	"./s-process.png": "./admin-thumbs/s-process.png",
	"./s-related.png": "./admin-thumbs/s-related.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./admin-thumbs sync recursive \\.png$";